import { useEffect, useState } from "react";
import { Button, Dropdown, Statistic } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import { useAuth } from "context/providers/auth";
import CreateUserPinModal from "./components/CreateUserPinModal";
import { useActivityProtect } from "components/ActivityProtect";
import ChangePasswordModal from "./components/ChangePasswordModal";

const UserPanel = () => {
  const {
    state: {
      is_admin,
      user: {
        full_name,
        session_expiration,
      },
    },
    handleLogoutLocally,
  } = useAuth();

  const [is_open, setOpenCreateModal] = useState(false);
  const [is_open_change_password_modal, setOpenChangePasswordModalModal] =
    useState(false);
  const [expiration_time, setExpirationTime] = useState(session_expiration);
  const navigate = useNavigate();
  const { remainingTime } = useActivityProtect();

  const minutes = Math.floor(remainingTime / 60);
  const seconds = Math.floor(remainingTime % 60);

  useEffect(() => {
    setExpirationTime(session_expiration);
  }, [session_expiration]);

  const onFinish = handleLogoutLocally;

  return (
    <>
      <Dropdown
        menu={{
          items: [
            {
              className: "username",
              key: "1",
              label: full_name,
              disabled: true,
            },

            is_admin && {
              key: "3",
              label: "Ustawienia",
              onClick: () => navigate("/settings"),
            },
            is_admin && {
              key: "8",
              label: "Moje faktury",
              onClick: () => navigate("/billings"),
            },
            {
              key: "4",
              label: "Historia logowań",
              onClick: () => navigate("/login_history"),
            },
            {
              key: "2",
              label: "Zmień kod PIN blokady ekranu",
              onClick: () => setOpenCreateModal(true),
            },
            {
              key: "7",
              label: "Zmień hasło",
              onClick: () => setOpenChangePasswordModalModal(true),
            },
            {
              key: "5",
              label: `Czas do blokady ekranu:\n${minutes}:${seconds < 10 ? `0${seconds}` : seconds
                }`,
            },
            {
              key: "6",
              label: (
                <>
                  Czas do końca sesji:
                  <Statistic.Timer
                    type="countdown"
                    value={expiration_time}
                    onFinish={onFinish}
                  />
                </>
              ),
            },
          ].filter(Boolean),
        }}
        placement="bottomRight"
        arrow
      >
        <Button type="primary" htmlType="button" icon={<UserOutlined />} />
      </Dropdown>
      <CreateUserPinModal
        is_open={is_open}
        handleClose={() => setOpenCreateModal(false)}
      />
      <ChangePasswordModal
        is_open={is_open_change_password_modal}
        handleClose={() => setOpenChangePasswordModalModal(false)}
      />
    </>
  );
};

export default UserPanel;
